webpackJsonp([11],{

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(840),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47689422",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_geo_hash__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_geo_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_geo_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixin_imageLinks__ = __webpack_require__(210);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = void 0;


/* harmony default export */ __webpack_exports__["default"] = ({
  metaInfo: function metaInfo() {
    return {
      title: "with a view"
    };
  },

  filters: {
    getName: function getName() {
      var str = vm.$route.query.loc;
      if (str.length > 20) {
        var s = str.substring(0, 20);
        return s + "...";
      } else {
        return str;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(["queried_locations"])),
  watch: {
    selectedFilterSort: function selectedFilterSort() {
      var _this = this;

      if (this.selectedFilterSort === "km") {
        localStorage.setItem("isLocationEnabled", "Y");
        this.$store.commit("getLocationFinal");
        setTimeout(function () {
          var t1 = setInterval(function () {
            if (!_this.$store.state.common.fetchLocLoader) {
              clearInterval(t1);
              if (_this.$store.state.gen.finalUserLocation != "") {
                _this.userGeo = __WEBPACK_IMPORTED_MODULE_7_geo_hash___default.a.decode(_this.$store.state.gen.finalUserLocation);
              } else {
                _this.selectedFilterSort = "ts";
              }
            }
          }, 20);
        }, 100);
      }
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixin_imageLinks__["a" /* default */]],
  data: function data() {
    return {
      selectedTagName: {
        name: "",
        type: ""
      },
      isAnyTagSelected: false,
      prevQ: {},
      filterStatus: "",
      userLoc: {},
      worldwide: false,
      selectedFilterSort: "ts",
      tags: {
        locationTag: {
          name: "Location",
          tagArr: [],
          selectedTags: []
        },
        emotionalAppeal: {
          tagLine: "Vibe of the view",
          name: "Emotional Appeal",
          tagArr: [],
          selectedTags: [],
          height: "small"
        },
        spotType: {
          tagLine: "View from",
          name: "Spot Type",
          tagArr: [],
          selectedTags: [],
          height: "big"
        },
        keywords: {
          tagLine: "View type",
          name: "Keywords",
          tagArr: [],
          selectedTags: [],
          height: "small"
        },
        viewType: {
          tagLine: "View Type",
          name: "View Type",
          tagArr: [],
          selectedTags: [],
          height: "small"
        }
      }
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.filterStatus === "apply") {

      this.filterStatus = "";
      var obj = {};
      if (this.tags.emotionalAppeal.selectedTags.length != 0) {
        obj.emotionalAppeal = [];
        for (var i in this.tags.emotionalAppeal.selectedTags) {
          obj.emotionalAppeal = this.tags.emotionalAppeal.selectedTags[i];
        }
      }
      if (this.tags.spotType.selectedTags.length != 0) {
        obj.st = this.tags.spotType.selectedTags[0];
      }
      if (this.tags.keywords.selectedTags.length != 0) {
        obj.keywords = this.tags.keywords.selectedTags[0];
      }
      obj.srt = this.selectedFilterSort;
      obj.srt === "km" ? obj.userGeo = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.userGeo) : "";
      obj.loc = localStorage.getItem("filterLocation").toLowerCase(); // this.worldwide? 'Elsewhere':'Berlin'
      console.log("OBJ:", obj);
      var mode = localStorage.getItem("MODE");
      this.$store.state.common.isModeSwipe = mode === null ? false : JSON.parse(mode);
      next({ path: to.path, query: obj });
    } else if (this.filterStatus === "clear") {
      this.filterStatus = "";
      var _mode2 = localStorage.getItem("MODE");
      this.$store.state.common.isModeSwipe = _mode2 === null ? false : JSON.parse(_mode2);
      next({ path: to.path, query: {} });
    } else {
      next();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(["query_location"]), {
    goToRoute: function goToRoute(selected) {
      if (localStorage.getItem("filterLocation")) {
        localStorage["filterLocation"] = selected;
      } else {
        localStorage.setItem("filterLocation", selected);
      }
      localStorage.removeItem("homePageImages");
      var obj = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      obj.loc = selected;
      console.log({ obj: obj });
      var _from = localStorage.getItem("from");
      if (_from === "Map") {
        this.$router.push({ path: "/map", query: obj });
      } else {
        var _mode = localStorage.getItem("Mode");
        this.$store.state.common.isModeSwipe = _mode === null ? false : JSON.parse(_mode);
        this.$router.push({ path: "/", query: obj });
      }
    },
    applyFilters: function applyFilters() {
      var _this2 = this;

      this.filterStatus = "apply";
      setTimeout(function () {
        // console.log("***********************",localStorage.getItem("from"))
        if (localStorage.getItem("from") === "search_locations") {
          _this2.$router.push({ path: "/" });
        } else {
          _this2.$router.push({ path: "/" });
        }
      }, 100);
    },
    goToLocation: function goToLocation() {
      var obj = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      this.$router.push({ path: "/search_locations", query: obj });
    },
    SelectTag: function SelectTag(varName, tag, tagIndex) {
      this.filterStatus = "clear";
      var ele_name = document.getElementById("tag-id-" + varName + "-" + tagIndex + "-name");
      var ele = document.getElementById("tag-id-" + varName + "-" + tagIndex);
      if (this.tags[varName].selectedTags.includes(tag)) {
        var n = this.tags[varName].selectedTags.indexOf(tag);
        this.isAnyTagSelected = false;
        ele.style.border = "none";
        ele_name.style.height = "unset";
        ele_name.style.borderTopLeftRadius = "unset";
        ele_name.style.borderTopRightRadius = "unset";
        ele_name.style.background = "linear-gradient(to top, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0))";
        this.tags[varName].selectedTags = "";
      } else {
        localStorage.removeItem("homePageImages");
        for (var key in this.tags) {
          this.tags[key].selectedTags = [];
        }
        ele_name.style.height = "100%";
        ele_name.style.borderTopLeftRadius = "0.5em";
        ele_name.style.borderTopRightRadius = "0.5em";
        ele_name.style.background = "rgba(0, 0, 0, 0.5)";
        // ele.style.width='100%'
        ele.style.backgroundBlendMode = "overlay";
        ele.style.border = "1px solid #f5a623";
        this.tags[varName].selectedTags.push(tag);
        this.applyFilters();
      }
    },
    clearFilter: function clearFilter() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var i, j, ele;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.filterStatus = "clear";
                for (i in _this3.tags) {
                  for (j in _this3.tags[i].tagArr) {
                    ele = document.getElementById("tag-id-" + i + "-" + j);

                    ele.style.height = "unset";
                    ele.style.width = "unset";
                  }
                  _this3.tags[i].selectedTags = [];
                }
                _this3.selectedFilterSort = "ts";
                _this3.worldwide = false;
                _this3.$router.replace("/filter");

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getTag: function getTag(tag) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var vm, tagRes;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                vm = _this4;
                _context2.next = 3;
                return _this4.$store.dispatch("getUserAllFilters", {
                  tag: tag
                });

              case 3:
                tagRes = _context2.sent;

                _this4.tags[tag].tagArr = tagRes;
                if (tag === "locationTag") {
                  _this4.tags[tag].tagArr.push({
                    tag: "worldwide",
                    photoId: "ppufsenqmpt7pbmfzogv"
                  });
                }
                if (tag === "keywords") {
                  setTimeout(function () {
                    _this4.prevQ = _this4.$route.query;
                    console.log("this.prevQ", _this4.prevQ);
                    var arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.prevQ);
                    if (arr.includes("sortBy")) {
                      _this4.selectedFilterSort = _this4.prevQ.sortBy;
                    }
                    function getFilterAlreadySelected(key) {
                      for (var i in vm.tags[key].tagArr) {
                        if (vm.tags[key].selectedTags.includes(vm.tags[key].tagArr[i].tag)) {
                          var ele_name = document.getElementById("tag-id-" + key + "-" + i + "-name");
                          var ele = document.getElementById("tag-id-" + key + "-" + i);
                          ele_name.style.height = "100%";
                          ele_name.style.borderTopLeftRadius = "0.5em";
                          ele_name.style.borderTopRightRadius = "0.5em";
                          ele_name.style.background = "rgba(0, 0, 0, 0.5)";
                          // ele.style.width='100%'
                          ele.style.backgroundBlendMode = "overlay";
                          ele.style.border = "1px solid #f5a623";
                        }
                      }
                    }
                    if (arr.includes("emotionalAppeal")) {
                      _this4.isAnyTagSelected = true;
                      vm.tags["emotionalAppeal"].selectedTags = vm.prevQ["emotionalAppeal"];
                      _this4.selectedTagName.name = vm.tags["emotionalAppeal"].selectedTags;
                      _this4.selectedTagName.type = "emotionalAppeal";

                      for (var ind in _this4.tags["emotionalAppeal"].tagArr) {
                        if (_this4.tags["emotionalAppeal"].tagArr[ind].tag === _this4.selectedTagName.name) _this4.selectedTagName.index = ind;
                      }
                      //this.selectedTagName.index = this.tags['emotionalAppeal'].tagArr.indexOf(this.selectedTagName.name)
                      getFilterAlreadySelected("emotionalAppeal");
                    }
                    if (arr.includes("viewType")) {
                      _this4.isAnyTagSelected = true;
                      vm.tags["viewType"].selectedTags = vm.prevQ["viewType"];
                      _this4.selectedTagName.name = vm.tags["viewType"].selectedTags;
                      _this4.selectedTagName.type = "viewType";

                      for (var _ind in _this4.tags["viewType"].tagArr) {
                        if (_this4.tags["viewType"].tagArr[_ind].tag === _this4.selectedTagName.name) _this4.selectedTagName.index = _ind;
                      }
                      //this.selectedTagName.index = this.tags['emotionalAppeal'].tagArr.indexOf(this.selectedTagName.name)
                      getFilterAlreadySelected("viewType");
                    }
                    if (arr.includes("spotType")) {
                      _this4.isAnyTagSelected = true;
                      vm.tags["spotType"].selectedTags = vm.prevQ["spotType"];
                      _this4.selectedTagName.name = vm.tags["spotType"].selectedTags;
                      _this4.selectedTagName.type = "spotType";
                      for (var _ind2 in _this4.tags["spotType"].tagArr) {
                        if (_this4.tags["spotType"].tagArr[_ind2].tag === _this4.selectedTagName.name) _this4.selectedTagName.index = _ind2;
                      }
                      console.log({ r_TAGS: vm.tags["spotType"] });
                      getFilterAlreadySelected("spotType");
                    }
                    if (arr.includes("keywords")) {
                      _this4.isAnyTagSelected = true;
                      vm.tags["keywords"].selectedTags = vm.prevQ["keywords"];
                      _this4.selectedTagName.name = vm.tags["keywords"].selectedTags;
                      _this4.selectedTagName.type = "keywords";

                      for (var _ind3 in _this4.tags["keywords"].tagArr) {
                        if (_this4.tags["keywords"].tagArr[_ind3].tag === _this4.selectedTagName.name) _this4.selectedTagName.index = _ind3;
                      }
                      //this.selectedTagName.index = this.tags['keywords'].tagArr.indexOf(this.selectedTagName.name)
                      getFilterAlreadySelected("keywords");
                    }
                    if (arr.includes("addressIndex")) {
                      _this4.isAnyTagSelected = true;
                      console.log(" vm.prevQ.addressIndex", vm.prevQ.addressIndex);
                      _this4.tags.locationTag.selectedTags = vm.prevQ.addressIndex;
                      console.log("this.tags.locationTag.selectedTags", _this4.tags.locationTag.selectedTags);
                      setTimeout(function () {
                        getFilterAlreadySelected("locationTag");
                      }, 10);
                    }
                    if (arr.includes("loc")) {
                      if (_this4.prevQ.loc === "Elsewhere") {
                        _this4.worldwide = true;
                        console.log("this.tags.locationTag 23", _this4.tags);
                        _this4.tags.locationTag.selectedTags === undefined ? _this4.tags.locationTag.selectedTags = [] : "";
                        _this4.tags.locationTag.selectedTags.push("worldwide");
                        getFilterAlreadySelected("locationTag");
                        console.log("this.tags.locationTag", _this4.tags.locationTag);
                      }
                    }
                  }, 400);
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }),
  created: function created() {
    vm = this;
    this.tags.locationTag.selectedTags = [];
    console.log("SEEEE", this.tags);
    this.getTag("locationTag");
    this.getTag("emotionalAppeal");
    this.getTag("spotType");
    this.getTag("keywords");
    if (this.$route.query.loc) {
      this.$store.state.search_loc.query_location = this.$route.query.loc;
      if (localStorage.getItem("filterLocation")) {
        localStorage["filterLocation"] = this.$route.query.loc;
      } else {
        localStorage.setItem("filterLocation", this.$route.query.loc);
      }
    } else {
      this.$store.state.search_loc.query_location = localStorage.getItem("filterLocation").toLowerCase();
      // if(localStorage.getItem("filterLocation")){
      //   localStorage["filterLocation"] = localStorage.getItem("filterLocation")
      // }else{
      //   localStorage.setItem("filterLocation","worldwide")
      // }
    }
  }
});

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(538);
exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".search-container[data-v-47689422]{width:100%;border-bottom:1px solid rgba(0,0,0,.2);padding-bottom:.2em}.search-container input[data-v-47689422]{width:100%;padding-left:1em;padding-right:1.2em;outline:none;color:#fff;font-size:14px;font-weight:700}.pointer[data-v-47689422]{cursor:pointer}.search-location-dropdown[data-v-47689422]{background-image:url(" + escape(__webpack_require__(810)) + ");background-repeat:no-repeat,repeat;background-position:right 3px top 50%,0 0;background-size:auto,100%,50%;border-radius:2px;width:150px;border:none;font-size:14px;color:#fff}.search-location-dropdown select[data-v-47689422]{outline:none!important}.search-location-dropdown option[data-v-47689422]{font-size:1.143em;color:#303030!important}.sort-select[data-v-47689422]{background:transparent url(\"/static/img/wav-down-arrow.svg\") no-repeat;outline:none;background-position:100% 10%;background-size:2em;font-size:.909em;background-color:#4a4a4a;padding:.5em;width:9em;color:#9b9b9b}.filter-footer-container[data-v-47689422]{position:relative;width:100%;bottom:2em;padding-top:.2em}.filter-footer-container .div-1[data-v-47689422]{padding-left:1em;font-size:1em;top:-1em;right:1em;color:#9b9b9b;background:#4a4a4a;position:absolute}.filter-footer-container .div-2[data-v-47689422]{width:100%;height:1px;background:#000}.filter-container[data-v-47689422]{position:relative;padding-top:10em;background-color:#4a4a4a;min-height:100vh}.filter-container .filter-main-container[data-v-47689422]{position:absolute;width:100%;top:3em;margin-bottom:2em}.filter-container .filter-main-container .filter-header[data-v-47689422]{padding-right:2.429em;text-align:right;height:7em;padding-top:1em}.filter-container .filter-main-container .clear_icon[data-v-47689422]{background:#4a4a4a;padding:0 .5em;position:absolute;top:-.5em;color:#fff;left:0}.filter-container .filter-main-container .t-1[data-v-47689422]{margin-right:.5em;font-size:1em;color:#9b9b9b}.filter-container .filter-main-container .div-1[data-v-47689422]{padding:0 1em;font-size:1em;top:-1em;right:1em;color:#9b9b9b;background:#4a4a4a;position:absolute}.filter-container .filter-main-container .div-2[data-v-47689422]{width:100%;height:1px;background:#000}@media screen and (max-width:375px) and (max-height:680px){.filter-container .scroll-contain[data-v-47689422]{overflow-y:scroll;height:350px}}.filter-container .filter-header-container[data-v-47689422]{position:relative;margin-bottom:2em}.filter-container .filter-header-container .div-1[data-v-47689422]{padding:0 1em;font-size:1.243em;top:-.65em;left:1em;color:#fff;background:#4a4a4a;position:absolute}.filter-container .filter-header-container .div-2[data-v-47689422]{width:100%;height:1px;background:#000}.filter-container .tagline[data-v-47689422]{font-size:1.143em;color:#9b9b9b;margin:1.5em 0 .5em}.filter-container .tagTypes[data-v-47689422]{display:-webkit-box;display:-ms-flexbox;display:flex;overflow-x:auto}.filter-container .tagTypes .tag-container[data-v-47689422]{background-position:50%;border-radius:.5em;margin:0 .5em;background-size:cover;width:11.429em;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.filter-container .tagTypes .tag-container .tagName[data-v-47689422]{border-bottom-left-radius:.5em;border-bottom-right-radius:.5em;width:100%;text-transform:capitalize;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;background:-webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.75)),to(transparent));background:linear-gradient(0deg,rgba(0,0,0,.75),transparent);padding:.5em;text-align:center;color:#fff;font-size:1em}.filter-container .tagTypes .tag-container .tagName i[data-v-47689422]{font-size:1.2em}.filter-container .clearButton[data-v-47689422]{border:1px solid #2c3e50;background-color:#fff;color:#2c3e50}.filter-container .applyButton[data-v-47689422],.filter-container .clearButton[data-v-47689422]{position:relative;bottom:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0;width:100%;outline:none;font-size:.909em;height:3em;font-weight:600}.filter-container .applyButton[data-v-47689422]{background-color:#2c3e50;color:#fff}.totalPhotos[data-v-47689422]{-webkit-transform:scale(1.2);transform:scale(1.2);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff;font-size:.818em}.totalPhotos i[data-v-47689422]{font-size:1.5em}.selected-tag-onload[data-v-47689422]{text-align:right}.selected-tag-onload .name[data-v-47689422],.selected-tag-onload[data-v-47689422]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.selected-tag-onload .name[data-v-47689422]{padding:.3em 1em;border:1px solid #f5a623;margin-bottom:1em;background-color:#000}.selected-tag-onload .name i[data-v-47689422]{margin-left:.3em}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/filter.vue"],"names":[],"mappings":"AAIA,mCACE,WAAY,AACZ,uCAA4C,AAC5C,mBAAsB,CACvB,AACD,yCACI,WAAY,AACZ,iBAAkB,AAClB,oBAAqB,AACrB,aAAc,AACd,WAAe,AACf,eAAgB,AAChB,eAAkB,CACrB,AACD,0BACE,cAAgB,CACjB,AACD,2CACE,+CAAkE,AAClE,mCAAqC,AAErC,0CAA4C,AAE5C,8BAAiC,AACjC,kBAAmB,AACnB,YAAa,AACb,YAAa,AACb,eAAgB,AAChB,UAAa,CACd,AACD,kDACI,sBAAyB,CAC5B,AACD,kDACI,kBAAmB,AACnB,uBAA0B,CAC7B,AACD,8BACE,uEAAwE,AACxE,aAAc,AACd,6BAA8B,AAC9B,oBAAqB,AACrB,iBAAmB,AACnB,yBAA0B,AAC1B,aAAe,AACf,UAAW,AACX,aAAe,CAChB,AACD,0CACE,kBAAmB,AACnB,WAAY,AACZ,WAAY,AACZ,gBAAmB,CACpB,AACD,iDACI,iBAAkB,AAClB,cAAe,AACf,SAAU,AACV,UAAW,AACX,cAAe,AACf,mBAAoB,AACpB,iBAAmB,CACtB,AACD,iDACI,WAAY,AACZ,WAAY,AACZ,eAAkB,CACrB,AACD,mCACE,kBAAmB,AACnB,iBAAkB,AAClB,yBAA0B,AAC1B,gBAAkB,CACnB,AACD,0DACI,kBAAmB,AACnB,WAAY,AACZ,QAAS,AACT,iBAAmB,CACtB,AACD,yEACM,sBAAuB,AACvB,iBAAkB,AAClB,WAAY,AACZ,eAAiB,CACtB,AACD,sEACM,mBAAoB,AACpB,eAAiB,AACjB,kBAAmB,AACnB,UAAY,AACZ,WAAa,AACb,MAAQ,CACb,AACD,+DACM,kBAAoB,AACpB,cAAe,AACf,aAAe,CACpB,AACD,iEACM,cAAe,AACf,cAAe,AACf,SAAU,AACV,UAAW,AACX,cAAe,AACf,mBAAoB,AACpB,iBAAmB,CACxB,AACD,iEACM,WAAY,AACZ,WAAY,AACZ,eAAkB,CACvB,AACD,2DACA,mDACI,kBAAmB,AACnB,YAAc,CACjB,CACA,AACD,4DACI,kBAAmB,AACnB,iBAAmB,CACtB,AACD,mEACM,cAAe,AACf,kBAAmB,AACnB,WAAa,AACb,SAAU,AACV,WAAa,AACb,mBAAoB,AACpB,iBAAmB,CACxB,AACD,mEACM,WAAY,AACZ,WAAY,AACZ,eAAkB,CACvB,AACD,4CACI,kBAAmB,AACnB,cAAe,AACf,mBAAwB,CAC3B,AACD,6CACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,eAAiB,CACpB,AACD,4DACM,wBAA4B,AAE5B,mBAAqB,AACrB,cAAgB,AAChB,sBAAuB,AACvB,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,iBAAkB,AACtB,sBAAuB,AACnB,mBAAoB,AAChB,oBAAsB,CACnC,AACD,qEACQ,+BAAiC,AACjC,gCAAkC,AAClC,WAAY,AACZ,0BAA2B,AAC3B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,+FAA6G,AAC7G,6DAA2E,AAC3E,aAAe,AACf,kBAAmB,AACnB,WAAa,AACb,aAAe,CACtB,AACD,uEACU,eAAiB,CAC1B,AACD,gDACI,yBAA0B,AAC1B,sBAAwB,AACxB,aAAe,CAkBlB,AACD,gGAlBI,kBAAmB,AACnB,SAAU,AACV,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,UAAW,AACX,WAAY,AACZ,aAAc,AACd,iBAAmB,AACnB,WAAY,AACZ,eAAiB,CAsBpB,AApBD,gDACI,yBAA0B,AAC1B,UAAa,CAkBhB,AACD,8BACE,6BAA8B,AACtB,qBAAsB,AAC9B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAa,AACb,gBAAmB,CACpB,AACD,gCACI,eAAiB,CACpB,AACD,sCAUE,gBAAkB,CACnB,AACD,kFAXE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CAiBnC,AAdD,4CAUI,iBAAmB,AACnB,yBAA0B,AAC1B,kBAAmB,AACnB,qBAAwB,CAC3B,AACD,8CACM,gBAAmB,CACxB","file":"filter.vue","sourcesContent":["\n.pointer[data-v-47689422] {\n  cursor: pointer;\n}\n.search-container[data-v-47689422] {\n  width: 100%;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  padding-bottom: 0.2em;\n}\n.search-container input[data-v-47689422] {\n    width: 100%;\n    padding-left: 1em;\n    padding-right: 1.2em;\n    outline: none;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: bold;\n}\n.pointer[data-v-47689422] {\n  cursor: pointer;\n}\n.search-location-dropdown[data-v-47689422] {\n  background-image: url(\"../../static/img/keyboard_arrow_down.svg\");\n  background-repeat: no-repeat, repeat;\n  /* arrow icon position (1em from the right, 50% vertical) , then gradient position*/\n  background-position: right 3px top 50%, 0 0;\n  /* icon size, then gradient */\n  background-size: auto, 100%, 50%;\n  border-radius: 2px;\n  width: 150px;\n  border: none;\n  font-size: 14px;\n  color: white;\n}\n.search-location-dropdown select[data-v-47689422] {\n    outline: none !important;\n}\n.search-location-dropdown option[data-v-47689422] {\n    font-size: 1.143em;\n    color: #303030 !important;\n}\n.sort-select[data-v-47689422] {\n  background: transparent url(\"/static/img/wav-down-arrow.svg\") no-repeat;\n  outline: none;\n  background-position: 100% 10%;\n  background-size: 2em;\n  font-size: 0.909em;\n  background-color: #4a4a4a;\n  padding: 0.5em;\n  width: 9em;\n  color: #9b9b9b;\n}\n.filter-footer-container[data-v-47689422] {\n  position: relative;\n  width: 100%;\n  bottom: 2em;\n  padding-top: 0.2em;\n}\n.filter-footer-container .div-1[data-v-47689422] {\n    padding-left: 1em;\n    font-size: 1em;\n    top: -1em;\n    right: 1em;\n    color: #9b9b9b;\n    background: #4a4a4a;\n    position: absolute;\n}\n.filter-footer-container .div-2[data-v-47689422] {\n    width: 100%;\n    height: 1px;\n    background: black;\n}\n.filter-container[data-v-47689422] {\n  position: relative;\n  padding-top: 10em;\n  background-color: #4a4a4a;\n  min-height: 100vh;\n}\n.filter-container .filter-main-container[data-v-47689422] {\n    position: absolute;\n    width: 100%;\n    top: 3em;\n    margin-bottom: 2em;\n}\n.filter-container .filter-main-container .filter-header[data-v-47689422] {\n      padding-right: 2.429em;\n      text-align: right;\n      height: 7em;\n      padding-top: 1em;\n}\n.filter-container .filter-main-container .clear_icon[data-v-47689422] {\n      background: #4a4a4a;\n      padding: 0 0.5em;\n      position: absolute;\n      top: -0.5em;\n      color: white;\n      left: 0;\n}\n.filter-container .filter-main-container .t-1[data-v-47689422] {\n      margin-right: 0.5em;\n      font-size: 1em;\n      color: #9b9b9b;\n}\n.filter-container .filter-main-container .div-1[data-v-47689422] {\n      padding: 0 1em;\n      font-size: 1em;\n      top: -1em;\n      right: 1em;\n      color: #9b9b9b;\n      background: #4a4a4a;\n      position: absolute;\n}\n.filter-container .filter-main-container .div-2[data-v-47689422] {\n      width: 100%;\n      height: 1px;\n      background: black;\n}\n@media screen and (max-width: 375px) and (max-height: 680px) {\n.filter-container .scroll-contain[data-v-47689422] {\n    overflow-y: scroll;\n    height: 350px;\n}\n}\n.filter-container .filter-header-container[data-v-47689422] {\n    position: relative;\n    margin-bottom: 2em;\n}\n.filter-container .filter-header-container .div-1[data-v-47689422] {\n      padding: 0 1em;\n      font-size: 1.243em;\n      top: -0.65em;\n      left: 1em;\n      color: white;\n      background: #4a4a4a;\n      position: absolute;\n}\n.filter-container .filter-header-container .div-2[data-v-47689422] {\n      width: 100%;\n      height: 1px;\n      background: black;\n}\n.filter-container .tagline[data-v-47689422] {\n    font-size: 1.143em;\n    color: #9b9b9b;\n    margin: 1.5em 0 0.5em 0;\n}\n.filter-container .tagTypes[data-v-47689422] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    overflow-x: auto;\n}\n.filter-container .tagTypes .tag-container[data-v-47689422] {\n      background-position: center;\n      background-size: cover;\n      border-radius: 0.5em;\n      margin: 0 0.5em;\n      background-size: cover;\n      width: 11.429em;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.filter-container .tagTypes .tag-container .tagName[data-v-47689422] {\n        border-bottom-left-radius: 0.5em;\n        border-bottom-right-radius: 0.5em;\n        width: 100%;\n        text-transform: capitalize;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n        background: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.75)), to(rgba(0, 0, 0, 0)));\n        background: linear-gradient(to top, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0));\n        padding: 0.5em;\n        text-align: center;\n        color: white;\n        font-size: 1em;\n}\n.filter-container .tagTypes .tag-container .tagName i[data-v-47689422] {\n          font-size: 1.2em;\n}\n.filter-container .clearButton[data-v-47689422] {\n    border: 1px solid #2c3e50;\n    background-color: white;\n    color: #2c3e50;\n    position: relative;\n    bottom: 0;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 0;\n    width: 100%;\n    outline: none;\n    font-size: 0.909em;\n    height: 3em;\n    font-weight: 600;\n}\n.filter-container .applyButton[data-v-47689422] {\n    background-color: #2c3e50;\n    color: white;\n    position: relative;\n    bottom: 0;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 0;\n    width: 100%;\n    outline: none;\n    font-size: 0.909em;\n    height: 3em;\n    font-weight: 600;\n}\n.totalPhotos[data-v-47689422] {\n  -webkit-transform: scale(1.2);\n          transform: scale(1.2);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: white;\n  font-size: 0.818em;\n}\n.totalPhotos i[data-v-47689422] {\n    font-size: 1.5em;\n}\n.selected-tag-onload[data-v-47689422] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  text-align: right;\n}\n.selected-tag-onload .name[data-v-47689422] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    padding: 0.3em 1em;\n    border: 1px solid #f5a623;\n    margin-bottom: 1em;\n    background-color: black;\n}\n.selected-tag-onload .name i[data-v-47689422] {\n      margin-left: 0.3em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(671);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("3da2b92e", content, true, {});

/***/ }),

/***/ 810:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0id2hpdGUiIHdpZHRoPSIxOHB4IiBoZWlnaHQ9IjE4cHgiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMFYweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik03LjQxIDguNTlMMTIgMTMuMTdsNC41OS00LjU4TDE4IDEwbC02IDYtNi02IDEuNDEtMS40MXoiLz48L3N2Zz4="

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "filter-main-container"
  }, [_c('i', {
    staticClass: "material-icons clear_icon pointer",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('div', {
    staticClass: "div-1"
  }, [_vm._v("Currently showing")]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-header white--text",
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.isAnyTagSelected) ? _c('div', [_vm._v("All spots")]) : _c('div', {
    staticClass: "selected-tag-onload"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n            " + _vm._s(_vm.selectedTagName.name) + "\n            "), _c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "1em",
      "margin-bottom": "-0.1em"
    },
    on: {
      "click": function($event) {
        return _vm.SelectTag(_vm.selectedTagName.type, _vm.selectedTagName.name, _vm.selectedTagName.index)
      }
    }
  }, [_vm._v("cancel")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center",
      "margin-top": "0.2em"
    }
  }, [_c('div', {
    staticClass: "t-1"
  }, [_vm._v("in")]), _vm._v(" "), _c('div', {
    staticClass: "t-2"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.search_loc.query_location),
      expression: "$store.state.search_loc.query_location"
    }],
    staticClass: "search-location-dropdown pointer",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.search_loc, "query_location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.query_location,
        _vm.goToRoute(_vm.$store.state.search_loc.query_location)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Worldwide")]), _vm._v(" "), _c('option', [_vm._v("Worldwide")]), _vm._v(" "), _c('option', [_vm._v("Barcelona")]), _vm._v(" "), _c('option', [_vm._v("Berlin")]), _vm._v(" "), _c('option', [_vm._v("Copenhagen (København)")]), _vm._v(" "), _c('option', [_vm._v("Florence (Firenze)")]), _vm._v(" "), _c('option', [_vm._v("Lisbon (Lisboa)")]), _vm._v(" "), _c('option', [_vm._v("London")]), _vm._v(" "), _c('option', [_vm._v("Los Angeles")]), _vm._v(" "), _c('option', [_vm._v("Madrid")]), _vm._v(" "), _c('option', [_vm._v("Milan (Milano)")]), _vm._v(" "), _c('option', [_vm._v("New York")]), _vm._v(" "), _c('option', [_vm._v("Paris")]), _vm._v(" "), _c('option', [_vm._v("Porto")]), _vm._v(" "), _c('option', [_vm._v("Rome (Roma)")]), _vm._v(" "), _c('option', [_vm._v("San Francisco")])])])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scroll-contain",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.tags), function(tag, tagName) {
    return _c('div', {
      key: tagName,
      staticClass: "text-xs-left pointer"
    }, [(tagName === 'spotType') ? _c('div', [_c('div', {
      staticClass: "pl-3 tagline"
    }, [_vm._v(_vm._s(tag.tagLine))]), _vm._v(" "), _c('div', {
      staticClass: "tagTypes"
    }, _vm._l((tag.tagArr), function(tagselect, tagIndex) {
      return _c('div', {
        key: tagIndex
      }, [_c('div', {
        staticClass: "tag-container",
        style: (("background-image: url(" + (_vm.filterImage(tagselect.photoId)) + "); height:" + (tag.height === 'small'? '6.429em': '11.429em'))),
        attrs: {
          "id": ("tag-id-" + tagName + "-" + tagIndex)
        },
        on: {
          "click": function($event) {
            return _vm.SelectTag(tagName, tagselect.tag, tagIndex)
          }
        }
      }, [_c('div', {
        staticClass: "tagName",
        attrs: {
          "id": ("tag-id-" + tagName + "-" + tagIndex + "-name")
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "left"
        }
      }, [_vm._v("\n                  " + _vm._s(tagselect.tag) + "\n                  "), (tagselect.pic_cnt > 0) ? _c('span', [_vm._v("(" + _vm._s(tagselect.pic_cnt) + ")")]) : _vm._e()]), _vm._v(" "), _c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (tag.selectedTags.includes(tagselect.tag)),
          expression: "tag.selectedTags.includes(tagselect.tag)"
        }],
        staticClass: "material-icons"
      }, [_vm._v("check_circle")])])])])
    }), 0)]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "filter-footer-container"
  }, [_c('div', {
    staticClass: "div-1"
  }, [_vm._v("\n      Results are sorted by\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFilterSort),
      expression: "selectedFilterSort"
    }],
    staticClass: "sort-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFilterSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ts"
    }
  }, [_vm._v("Upload Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lks"
    }
  }, [_vm._v("Likes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "km"
    }
  }, [_vm._v("Distance")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "random"
    }
  }, [_vm._v("Random")])])]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-header-container"
  }, [_c('div', {
    staticClass: "div-1"
  }, [_vm._v("Select a filter to limit results")]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  })])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/v/1733832636781/js/11.561a65d4bad1dc7c77b7.js